var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBurger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 28.3333C5 29.2538 5.74619 30 6.66667 30H33.3333C34.2538 30 35 29.2538 35 28.3333C35 27.4129 34.2538 26.6667 33.3333 26.6667H6.66667C5.74619 26.6667 5 27.4129 5 28.3333ZM5 20C5 20.9205 5.74619 21.6667 6.66667 21.6667H33.3333C34.2538 21.6667 35 20.9205 35 20C35 19.0795 34.2538 18.3333 33.3333 18.3333H6.66667C5.74619 18.3333 5 19.0795 5 20ZM6.66667 10C5.74619 10 5 10.7462 5 11.6667C5 12.5871 5.74619 13.3333 6.66667 13.3333H33.3333C34.2538 13.3333 35 12.5871 35 11.6667C35 10.7462 34.2538 10 33.3333 10H6.66667Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.b6e22befa87393eebf5f71ad34a269df.svg";
export { ForwardRef as ReactComponent };